export default __webpack_public_path__ + "static/media/duckavatar.d98da37e.jpg";